import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleDAO } from '../../../../../core/services/dao/roleDAO';
import { Role } from 'anchor-shared/lib/model/entity/role';
import { ConstantMan } from '../../../../../core/services/constantMan';
import { Permission } from 'anchor-shared/lib/model/entity/permission';

@Component({
  selector: 'app-edit-role',
  templateUrl: './edit-role.component.html',
})
export class EditRoleComponent implements OnInit {
  public model: Role;
  public selectedId: any;
  public rolePermissions: Permission[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleDAO: RoleDAO,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.selectedId = +params['id'];
      // this.model = this.roleDAO.getById(this.selectedId) as Role;
      this.rolePermissions = this.model['rolePermissionMap'];
    });
  }

  onSubmitted(roleForm: any) {
    let role = roleForm.role;
    let permissions = ConstantMan.DEFAULT_PERMISSIONS.concat(
      roleForm.permissions,
    );

    let ctrl = this;
    this.roleDAO.updateRole(role, permissions).subscribe(
      (result) => {
        ctrl.router.navigate(['manage/admin/roles']);
      },
      (error) => {
        console.error(error);
      },
    );
  }

  onCancelled() {
    this.router.navigate(['manage/admin/roles']);
  }
}
